import { logger } from "./shared/logger";
import { initEnvironmentRibbon } from "./shared/ribbon";
import "../css/styles.css";

// --- VERSIONING ---
const DEPLOY_ID = "V-2.0.0-STATIC-VITE";
logger.banner(DEPLOY_ID);
initEnvironmentRibbon();

document.addEventListener('DOMContentLoaded', () => {
    logger.log(`[${DEPLOY_ID}] DOM Ready.`);

    // --- MOBILE MENU LOGIC ---
    const mobileMenuBtn = document.getElementById('mobile-menu-btn');
    const mobileMenu = document.getElementById('mobile-menu');

    if (mobileMenuBtn && mobileMenu) {
        mobileMenuBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            const isHidden = mobileMenu.style.display === 'none' || mobileMenu.style.display === '';
            mobileMenu.style.display = isHidden ? 'flex' : 'none';
        });

        document.addEventListener('click', (e) => {
            if (mobileMenu.style.display === 'flex' && !mobileMenu.contains(e.target as Node) && e.target !== mobileMenuBtn) {
                mobileMenu.style.display = 'none';
            }
        });

        document.querySelectorAll('.mobile-link').forEach(link => {
            link.addEventListener('click', () => { mobileMenu.style.display = 'none'; });
        });
    }

    // Planos Toggle
    const btnMei = document.getElementById('btn-mei');
    const btnSimples = document.getElementById('btn-simples');
    const planosMei = document.getElementById('planos-mei');
    const planosSimples = document.getElementById('planos-simples');

    if (btnMei && btnSimples && planosMei && planosSimples) {
        const setActive = (activeBtn: HTMLElement, inactiveBtn: HTMLElement, showGrid: HTMLElement, hideGrid: HTMLElement) => {
            activeBtn.classList.add('bg-primary', 'text-white', 'shadow-lg');
            activeBtn.classList.remove('text-gray-600', 'hover:text-primary');
            inactiveBtn.classList.remove('bg-primary', 'text-white', 'shadow-lg');
            inactiveBtn.classList.add('text-gray-600', 'hover:text-primary');
            showGrid.classList.remove('hidden');
            hideGrid.classList.add('hidden');
        };
        btnMei.addEventListener('click', () => setActive(btnMei, btnSimples, planosMei, planosSimples));
        btnSimples.addEventListener('click', () => setActive(btnSimples, btnMei, planosSimples, planosMei));
    }

    // --- ANCHOR SCROLL FIX ---
    const handleAnchorClick = (e: Event, href: string) => {
        const target = document.querySelector(href);
        if (target) {
            e.preventDefault();

            // Força o fechamento do menu mobile antes de calcular a posição
            if (mobileMenu && mobileMenu.style.display === 'flex') {
                mobileMenu.style.display = 'none';
            }

            const header = document.querySelector('header');
            const headerHeight = header ? header.offsetHeight : 100;
            const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });

            history.pushState(null, '', href);
        }
    };

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(this: HTMLAnchorElement, e) {
            const href = this.getAttribute('href');
            if (href && href !== '#' && href.startsWith('#')) {
                handleAnchorClick(e, href);
            }
        });
    });

    document.querySelectorAll('.mobile-link').forEach(link => {
        link.addEventListener('click', function(this: HTMLAnchorElement, e) {
            const href = this.getAttribute('href');
            if (href && href.startsWith('#')) {
                handleAnchorClick(e, href);
            }
        });
    });
});
